module.exports = __webpack_public_path__ + "img/Icons-13.fb2e0a15.svg";